import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { TAGS, TEXT } from '../../../../content';
import { ROUTE, PATH } from '../../../../constants';
import './SideMenu.css';
import { scrollToTop } from '../../../../utils';
import MuteSwitch from './MuteSwitch/MuteSwitch';

// note - revise router implementation (kind of hack now)

const SideMenu = props => {
  const { location } = props;
  const pathSplit = location.pathname.split('/');
  const activeCategory = pathSplit.length < 3 ? -1 : pathSplit[2];
  const detailActive = pathSplit.length === 4;

  const links = Object.keys(TAGS).map(key => (
    <Link
      key={key}
      className={`link ${key < 100 ? 'type0' : 'type1'} ${
        key === activeCategory ? 'selected' : ''
      }`}
      to={`${ROUTE.CATEGORY}/${key}`}
      onClick={scrollToTop}
    >
      <img src={`${PATH.IMG}title/${key}.png`} alt={TAGS[key]} />
    </Link>
  ));

  return (
    <div id="side-menu" className={detailActive ? 'detail' : ''}>
      <Link to="/">
        <div id="menu-logo-wrap">
          <img
            id="menu-logo"
            src={`${PATH.IMG}vary/intro-logo.png`}
            alt="1968 Rekonstrukce okupace"
          />
        </div>
      </Link>
      <Link className="link dark" to={ROUTE.ABOUT} onClick={scrollToTop}>
        <img
          src={`${PATH.IMG}title/o-projektu.png`}
          alt={TEXT.PROJECT_INFO_TITLE}
        />
      </Link>
      {links}
      <MuteSwitch />
    </div>
  );
};

export default withRouter(SideMenu);



// WEBPACK FOOTER //
// ./src/components/App/Okupace/SideMenu/SideMenu.js